import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace("#", "")).get("session_id");
    const target = location.pathname && location.pathname !== "/" ? location.pathname : "/account";
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true, state: { user: data } });
      } catch {
        navigate(target, { replace: true, state: { authError: true } });
      }
    })();
  }, [location.hash, location.pathname, navigate, setUser]);

  return <div className="min-h-screen flex items-center justify-center text-sm text-slate-500" data-testid="auth-callback">Signing you in…</div>;
}
